"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OcppIdTokenAuthorizationSource = void 0;
var OcppIdTokenAuthorizationSource;
(function (OcppIdTokenAuthorizationSource) {
    OcppIdTokenAuthorizationSource[OcppIdTokenAuthorizationSource["OcppLive"] = 1] = "OcppLive";
    OcppIdTokenAuthorizationSource[OcppIdTokenAuthorizationSource["LocalAuthList"] = 2] = "LocalAuthList";
    OcppIdTokenAuthorizationSource[OcppIdTokenAuthorizationSource["NotAvailable"] = 3] = "NotAvailable";
})(OcppIdTokenAuthorizationSource = exports.OcppIdTokenAuthorizationSource || (exports.OcppIdTokenAuthorizationSource = {}));
